import * as React from 'react'

function LogoLinkedIn({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMid meet"
      className="w-full h-full fill-current"
      {...props}
    >
      <path d="M6.478 22H2.33V8.647h4.148zM4.402 6.826C3.076 6.826 2 5.728 2 4.402a2.402 2.402 0 1 1 4.804 0c0 1.326-1.076 2.424-2.402 2.424M21.996 22h-4.139v-6.5c0-1.55-.031-3.536-2.156-3.536-2.156 0-2.487 1.683-2.487 3.424V22H9.071V8.647h3.978v1.822h.058c.554-1.05 1.906-2.156 3.924-2.156 4.197 0 4.969 2.763 4.969 6.352V22z" />
    </svg>
  )
}

function LogoFacebook({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMid meet"
      className="w-full h-full fill-current"
      {...props}
    >
      <path d="M8.578 13.691V22h4.531v-8.309h3.38l.702-3.82H13.11V8.52c0-2.02.793-2.793 2.84-2.793.637 0 1.149.015 1.446.046V2.31C16.835 2.156 15.469 2 14.68 2c-4.176 0-6.102 1.973-6.102 6.227V9.87H6v3.82z" />
    </svg>
  )
}

function LogoYouTube({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMid meet"
      className="w-full h-full fill-current"
      {...props}
    >
      <path d="M20.583 7.191a2.5 2.5 0 0 0-1.769-1.772C17.254 5 11 5 11 5s-6.254 0-7.814.42c-.86.229-1.538.907-1.769 1.771C1 8.755 1 12.015 1 12.015s0 3.259.417 4.823c.231.864.909 1.513 1.769 1.743C4.746 19 11 19 11 19s6.254 0 7.814-.42a2.47 2.47 0 0 0 1.769-1.742C21 15.274 21 12.015 21 12.015s0-3.26-.417-4.824M8.957 14.975v-5.92l5.225 2.96z" />
    </svg>
  )
}

function LogoThreads({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMid meet"
      className="w-full h-full fill-current"
      {...props}
    >
      <path d="M16.963 11.152c.09.038.173.08.26.117 1.2.587 2.082 1.466 2.542 2.558.646 1.52.708 3.99-1.247 5.965C17.029 21.3 15.215 21.98 12.65 22h-.012c-2.889-.02-5.107-1.004-6.601-2.924C4.707 17.368 4.025 14.989 4 12.01v-.02c.02-2.979.704-5.358 2.033-7.066C7.527 3.004 9.749 2.021 12.638 2h.012c2.893.02 5.14 1 6.68 2.912.756.946 1.316 2.083 1.67 3.403l-1.663.45c-.292-1.075-.732-1.991-1.325-2.724-1.201-1.492-3.004-2.258-5.37-2.275-2.346.021-4.12.783-5.276 2.266-1.078 1.388-1.638 3.396-1.658 5.966.02 2.57.58 4.578 1.658 5.97 1.153 1.483 2.93 2.245 5.276 2.266 2.115-.017 3.514-.525 4.679-1.704 1.33-1.341 1.304-2.991.88-3.995-.25-.592-.703-1.083-1.312-1.454-.152 1.12-.486 2.012-1.017 2.7-.703.908-1.703 1.4-2.991 1.47-.972.054-1.906-.183-2.63-.667-.856-.574-1.358-1.45-1.411-2.47-.103-2.012 1.469-3.458 3.917-3.6q1.305-.076 2.436.118c-.098-.617-.3-1.109-.6-1.467-.412-.487-1.054-.737-1.902-.741h-.028c-.684 0-1.605.191-2.194 1.095l-1.415-.983c.79-1.212 2.07-1.879 3.613-1.879h.033c2.576.017 4.11 1.646 4.267 4.487l-.008.008zm-6.42 2.866c.054 1.046 1.169 1.533 2.247 1.47 1.054-.057 2.247-.474 2.449-3.048a8.3 8.3 0 0 0-1.786-.184q-.296-.001-.593.017c-1.765.1-2.354.966-2.313 1.741z" />
    </svg>
  )
}

function LogoBluesky({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMid meet"
      className="w-full h-full fill-current"
      {...props}
    >
      <path d="M6.335 4.212c2.293 1.76 4.76 5.327 5.665 7.242.906-1.915 3.372-5.483 5.665-7.242C19.319 2.942 22 1.96 22 5.086c0 .624-.35 5.244-.555 5.994-.714 2.608-3.316 3.273-5.63 2.87 4.045.704 5.074 3.035 2.852 5.366-4.22 4.426-6.066-1.111-6.54-2.53-.086-.26-.126-.382-.127-.278 0-.104-.041.018-.128.278-.473 1.419-2.318 6.956-6.539 2.53-2.222-2.331-1.193-4.662 2.852-5.366-2.314.403-4.916-.262-5.63-2.87C2.35 10.33 2 5.71 2 5.086c0-3.126 2.68-2.144 4.335-.874" />
    </svg>
  )
}

function LogoTwitter({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMid meet"
      className="w-full h-full fill-current"
      {...props}
    >
      <path d="M17.75 3h3.068l-6.702 7.624L22 21h-6.171l-4.837-6.291L5.464 21H2.39l7.167-8.156L2 3h6.328l4.367 5.75zm-1.078 16.174h1.7L7.401 4.731H5.577z" />
    </svg>
  )
}

export { LogoLinkedIn, LogoFacebook, LogoThreads, LogoBluesky, LogoYouTube, LogoTwitter }
